import $ from 'jquery';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	var rootMarginVal;
	if (MQ('mdDown')) {
		rootMarginVal = '400px 0px -50px 0px';
	} else {
		rootMarginVal = '200px 0px -150px 0px';
	}
	const targets = document.querySelectorAll('.js-relevate');
	const options = {
		rootMargin: rootMarginVal,
	};
	function handleIntersection(entries) {
		entries.map((entry) => {
			if (entry.isIntersecting) {
				const dataAttr = entry.target.dataset.animation;
				if (dataAttr) {
					entry.target.classList.add('visible');
					entry.target.classList.remove(dataAttr);
				}
				observer.unobserve(entry.target);
			} else {
				entry.target.classList.remove('visible');
			}
		});
	}
	const observer = new IntersectionObserver(handleIntersection, options);
	//observer.observe(target);
	setTimeout(() => {
		Array.from(targets).forEach((target) => observer.observe(target));
	}, 10);
};
